var map = {
	"./": 3160,
	"./block_1.png": 8136,
	"./block_2.png": 9480,
	"./block_3.png": 4154,
	"./block_4.png": 6269,
	"./btn_close_control.png": 5007,
	"./btn_color_five.png": 337,
	"./btn_color_five_selected.png": 4108,
	"./btn_color_four.png": 9216,
	"./btn_color_four_selected.png": 3614,
	"./btn_color_one.png": 5575,
	"./btn_color_one_selected.png": 6286,
	"./btn_color_six.png": 8967,
	"./btn_color_six_selected.png": 2222,
	"./btn_color_three.png": 6402,
	"./btn_color_three_selected.png": 505,
	"./btn_color_two.png": 8778,
	"./btn_color_two_selected.png": 5072,
	"./btn_eraser.png": 1432,
	"./btn_marker_black.png": 1389,
	"./btn_marker_blue.png": 6399,
	"./btn_marker_green.png": 502,
	"./btn_marker_orange.png": 2885,
	"./btn_marker_red.png": 9419,
	"./btn_marker_yellow.png": 4132,
	"./btn_pen_black.png": 1183,
	"./btn_pen_blue.png": 7905,
	"./btn_pen_green.png": 7257,
	"./btn_pen_orange.png": 8050,
	"./btn_pen_red.png": 1226,
	"./btn_pen_yellow.png": 6579,
	"./btn_reset_control.png": 3270,
	"./btn_save_control.png": 1891,
	"./btn_weight_size_five.png": 1875,
	"./btn_weight_size_five_selected.png": 8304,
	"./btn_weight_size_four.png": 4990,
	"./btn_weight_size_four_selected.png": 9258,
	"./btn_weight_size_one.png": 7052,
	"./btn_weight_size_one_selected.png": 8873,
	"./btn_weight_size_six.png": 5355,
	"./btn_weight_size_six_selected.png": 3247,
	"./btn_weight_size_three.png": 900,
	"./btn_weight_size_three_selected.png": 5498,
	"./btn_weight_size_two.png": 2061,
	"./btn_weight_size_two_selected.png": 9900,
	"./ic_arrow_down.png": 1104,
	"./ic_block_pen.png": 1504,
	"./ic_home.png": 110,
	"./ic_home_primary.png": 6876,
	"./ic_home_white.png": 4994,
	"./ic_pen.png": 2938,
	"./ic_pencil_button.png": 9458,
	"./ic_record_round.png": 2072,
	"./ic_template_title.png": 2515,
	"./img_eng.png": 3948,
	"./img_math.png": 1506,
	"./index": 3160,
	"./index.ts": 3160,
	"./logo.png": 9819,
	"./temple_black.png": 1559,
	"./temple_color_1.png": 7004,
	"./temple_color_2.png": 2159,
	"./temple_color_3.png": 1858,
	"./temple_color_4.png": 2050,
	"./temple_color_5.png": 3402,
	"./temple_color_6.png": 5800,
	"./temple_emty_blu.png": 8431,
	"./temple_emty_bro.png": 9398,
	"./temple_emty_gre.png": 2897,
	"./temple_emty_pp.png": 4479,
	"./temple_emty_red.png": 577,
	"./temple_emty_yel.png": 6716,
	"./temple_grid_1.png": 953,
	"./temple_grid_1_1.png": 4345,
	"./temple_line_1.png": 3860,
	"./temple_line_2.png": 8869,
	"./temple_line_3.png": 1434,
	"./temple_onlyone1.png": 8194,
	"./temple_onlyone2.png": 2534,
	"./temple_onlyone3.png": 9994,
	"./temple_onlyone4.png": 7845,
	"./temple_pastel_1.png": 7124,
	"./temple_pastel_2.png": 6332,
	"./temple_pastel_3.png": 4323,
	"./temple_pastel_4.png": 4498,
	"./temple_postit_1.png": 7683,
	"./temple_postit_2.png": 2966,
	"./temple_postit_3.png": 2757,
	"./temple_postit_4.png": 6014,
	"./temple_white.png": 2750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;